<template>
  <div class="required login">
    <div class="logo-wrapper"></div>
    <el-card class="login-form-layout lg:w-1/3 md:w-1/2">
      <el-form autoComplete="off" class="my-5 mx-6" :model="loginForm" :rules="loginRules" ref="loginForm"  label-position="left">
        <h2 class="login-title mb-5">重置密码</h2>

        <el-form-item prop="password">
          <el-input :type="pwdType" v-model="loginForm.password" autoComplete="off" placeholder="请输入密码">
              <span slot="prefix">
                <svg-icon icon-class="password" class="color-main"></svg-icon>
              </span>
          </el-input>
        </el-form-item>

        <el-form-item prop="repeatPassword">
          <el-input :type="pwdType" v-model="loginForm.repeatPassword" autoComplete="off" placeholder="请输入确认密码">
              <span slot="prefix">
                <svg-icon icon-class="password" class="color-main"></svg-icon>
              </span>
          </el-input>
        </el-form-item>

        <div v-if="loginForm.method==1">
          <el-form-item prop="phone">
            <el-input type="text" :disabled="true" v-model="loginForm.phone" autoComplete="off" placeholder="请输入手机号">
            <span slot="prefix">
              <svg-icon icon-class="user" class="color-main"></svg-icon>
            </span>
            </el-input>
          </el-form-item>
        </div>
        <div v-else>
          <el-form-item prop="email">
            <el-input type="text" :disabled="true" v-model="loginForm.email" autoComplete="off" placeholder="请输入邮箱">
            <span slot="prefix">
              <svg-icon icon-class="user" class="color-main"></svg-icon>
            </span>
            </el-input>
          </el-form-item>
        </div>

        <el-form-item prop="verifyCode">
          <el-input type="text" v-model="loginForm.verifyCode" autoComplete="off" placeholder="请输入验证码">
              <span slot="prefix">
                <svg-icon icon-class="code" class="color-main"></svg-icon>
              </span>
            <span slot="suffix" >
                <button type="button" @click="getVerifyCode" class="px-3 py-2 rounded" :class="[!canClick?'verifyBtn':'noActiveVerityBtn']" :disabled="canClick">
                  {{ content }}
                </button>
              </span>
          </el-input>
        </el-form-item>

        <el-form-item label-width="0" class="mt-10">
          <el-button class="goBackBtn" style="width:47%;" @click="goBack" size="medium">
            返回
          </el-button>
          <el-button style="width:47%;margin-left:6%;background-color: #123B7F;color:#FFF;" @click="submit" size="medium">
            确认提交
          </el-button>
        </el-form-item>


      </el-form>

    </el-card>
  </div>
</template>

<script>
export default {
  name: "resetPassword",
  data(){
    const validatePass = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error('密码不能小于6位'))
      } else {
        callback()
      }
    };
    const checkedRepeatPass = (rule, value, callback)=>{
      if(value.length < 6){
        callback(new Error('密码不能小于6位'))
      }else if(this.loginForm.password!=value){
        callback(new Error('两次输入密码不一致!'))
      }else {
        callback()
      }
    };
    const checkVerifyCode = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入验证码"));
      } if (value.length!=6) {
        callback(new Error("请输入正确的验证码!"));
      } else {
        callback();
      }
    };
    return {
      loginForm:{
        method:1,
        phone:"",
        email:"",
        verifyCode:"",
        password:"",
        repeatPassword:"",
      },
      pwdType: 'password',
      loginRules: {
        password: [{required: true, trigger: 'blur', validator: validatePass}],
        repeatPassword: [{required: true, trigger: 'blur', validator: checkedRepeatPass}],
        verifyCode: [
          { required: true, trigger: 'blur',validator: checkVerifyCode }
        ]
      },
      content: '获取验证码',
      totalTime: 60,
      canClick: false
    }
  },
  created() {
    this.loginForm.method = this.$route.params.loginForm.method;
    this.loginForm.phone = this.$route.params.loginForm.phone;
    this.loginForm.email = this.$route.params.loginForm.email;
  },
  methods:{
    //获取验证码接口
    getVerifyCode(){
      // console.log("获取验证码接口");
      if (this.canClick){
        return
      }else{
        this.canClick = true
        this.content = this.totalTime + 's后重新获取'
        let clock = window.setInterval(() => {
          this.totalTime--
          this.content = this.totalTime + 's后重新获取'
          if (this.totalTime < 0) {
            window.clearInterval(clock)
            this.content = '获取验证码'
            this.totalTime = 60
            this.canClick = false
          }
        }, 1000)
      }
    },
    //返回上一页
    goBack(){
      this.$router.push({
        path: '/findPassword'
      });
    },
    submit(){
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          console.log("提交");
        } else {
          this.$message('参数验证不合法！');
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
.login {
  position: relative;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url("//emhub-static-assets3.oss-cn-hangzhou.aliyuncs.com/login_bg.png");
  background-size: cover;
  background-repeat: no-repeat;
}
.login-title {
  font-size: 1.875rem;
  font-weight: bold;
  color: #333333;
  letter-spacing: 2px;
  text-align: center;
}

.color-main{
  color: #123B7F;
}
.login-form-layout {
  position: absolute;
  left: 0;
  right: 0;
  /*width: 28rem;*/
  margin: 140px auto;
}
.verifyCodeBtn{
  border-color: #123B7F;
}
.verifyCodeBtn:hover{
  background-color: #123B7F;
  color: #FFFFFF;
}
.verifyBtn{
  background: #123B7F;
  color:#fff;
  font-size: 14px;
  line-height: 20px;
}
.noActiveVerityBtn{
  background: #ccc;
  color:#fff;
  font-size: 14px;
  line-height: 20px;
}
/deep/ .el-input__inner:focus{
  border-color: #123B7F;
}

/deep/ .el-radio-button__inner:hover{
  color: #123B7F;
}

/deep/ .el-input__inner {
  /*width: 220px;*/
  border-radius: 0px;
  border-top-width: 0px;
  border-left-width: 0px;
  border-right-width: 0px;
  border-bottom-width: 1px;
  /*outline: medium;*/
}
.goBackBtn{
  color: #123B7F;
  border-color: #123B7F;
}
.goBackBtn:hover{
  background-color: #123B7F;
  color: #FFFFFF;
}
</style>